import axios from "axios";
import { hudLoginApiUrl } from "../../constants/apis/hud_apis";

export const hudLogin = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const response = await axios.post(hudLoginApiUrl, data, config);

    return response;
};
